/**
 * Bambe collection ad pin: ?p=PRODUCT_ID
 * If the product is in the collection, move/inject it as the first grid item.
 * Visual cue is optional (section settings on #product-grid data attrs).
 */
(function () {
  'use strict';

  var PIN_ATTR = 'data-bambe-pinned';
  var ID_ATTR = 'data-product-id';

  function getRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root;
  }

  function readPinFromUrl() {
    try {
      var p = new URLSearchParams(window.location.search).get('p');
      if (p && /^\d+$/.test(String(p).trim())) return String(p).trim();
    } catch (e) {}
    return '';
  }

  function rememberPin(id) {
    if (!id) return;
    window.__bambePinProductId = id;
    window.__bambePinCollectionPath = window.location.pathname;
  }

  function getPinId() {
    var fromUrl = readPinFromUrl();
    if (fromUrl) {
      rememberPin(fromUrl);
      return fromUrl;
    }
    if (
      window.__bambePinProductId &&
      window.__bambePinCollectionPath === window.location.pathname
    ) {
      return String(window.__bambePinProductId);
    }
    return '';
  }

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function collectionPath(grid) {
    var url = (grid && grid.getAttribute('data-collection-url')) || window.location.pathname;
    try {
      if (url.indexOf('http') === 0) {
        var u = new URL(url);
        return u.pathname.replace(/\/$/, '') || u.pathname;
      }
    } catch (e) {}
    return String(url).replace(/\/$/, '') || '/collections/all';
  }

  function highlightEnabled(grid) {
    return grid && grid.getAttribute('data-pin-highlight') === 'true';
  }

  function highlightStyle(grid) {
    return (grid && grid.getAttribute('data-pin-style')) || 'border';
  }

  function badgeLabel() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (lang.indexOf('fr') === 0) return 'Sélection';
    return 'مميز';
  }

  function clearHighlight(item) {
    if (!item) return;
    item.classList.remove(
      'bambe-pin-item',
      'bambe-pin-item--border',
      'bambe-pin-item--badge',
      'bambe-pin-item--glow'
    );
    var badge = item.querySelector('.bambe-pin-badge');
    if (badge) badge.remove();
  }

  function applyHighlight(grid, item) {
    clearHighlight(item);
    if (!highlightEnabled(grid)) return;
    var style = highlightStyle(grid);
    item.classList.add('bambe-pin-item', 'bambe-pin-item--' + style);
    if (style === 'badge' && !item.querySelector('.bambe-pin-badge')) {
      var el = document.createElement('span');
      el.className = 'bambe-pin-badge';
      el.textContent = badgeLabel();
      item.insertBefore(el, item.firstChild);
    }
  }

  function findItems(grid, productId) {
    return Array.prototype.slice.call(
      grid.querySelectorAll('.tp-grid__item[' + ID_ATTR + '="' + productId + '"]')
    );
  }

  function ensureAtTop(grid, productId) {
    var items = findItems(grid, productId);
    if (!items.length) return false;

    var keep = items[0];
    for (var i = 1; i < items.length; i++) {
      items[i].remove();
    }

    keep.setAttribute(PIN_ATTR, 'true');
    if (grid.firstElementChild !== keep) {
      grid.insertBefore(keep, grid.firstElementChild);
    }
    applyHighlight(grid, keep);
    return true;
  }

  function fetchCollectionProduct(collectionUrlPath, productId) {
    var path = collectionUrlPath;
    if (path.charAt(0) !== '/') path = '/' + path;
    var page = 1;
    var maxPages = 20;

    function next() {
      if (page > maxPages) return Promise.resolve(null);
      var url =
        path +
        '/products.json?limit=250&page=' +
        page +
        '&_=' +
        Date.now();
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .then(function (data) {
          if (!data || !data.products || !data.products.length) return null;
          var found = data.products.find(function (p) {
            return String(p.id) === String(productId);
          });
          if (found) return found;
          if (data.products.length < 250) return null;
          page += 1;
          return next();
        })
        .catch(function () {
          return null;
        });
    }

    return next();
  }

  function fetchProductCard(handle) {
    var url = getRoot() + 'products/' + encodeURIComponent(handle) + '?view=card';
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) return '';
      return res.text();
    });
  }

  function injectCard(grid, productId, html) {
    if (!html || !html.trim()) return false;
    var li = document.createElement('li');
    li.className = 'tp-grid__item';
    li.setAttribute(ID_ATTR, productId);
    li.setAttribute(PIN_ATTR, 'true');
    li.innerHTML = html.trim();
    grid.insertBefore(li, grid.firstElementChild);
    applyHighlight(grid, li);
    try {
      if (window.tpCountdownTimer && typeof window.tpCountdownTimer.init === 'function') {
        window.tpCountdownTimer.init();
      }
      if (
        window.tpColorSwatchesShopify &&
        typeof window.tpColorSwatchesShopify.init === 'function'
      ) {
        window.tpColorSwatchesShopify.init();
      }
    } catch (e) {}
    return true;
  }

  function hasActiveFilters() {
    try {
      var params = new URLSearchParams(window.location.search);
      var skip = { p: true, page: true, sort_by: true, section_id: true };
      var active = false;
      params.forEach(function (_v, key) {
        if (!skip[key] && (key.indexOf('filter.') === 0 || key === 'q')) active = true;
      });
      return active;
    } catch (e) {
      return false;
    }
  }

  var running = false;

  function runPin(options) {
    options = options || {};
    var allowFetch = options.allowFetch !== false;
    var grid = getGrid();
    var productId = getPinId();
    if (!grid || !productId) return Promise.resolve(false);
    if (running) return Promise.resolve(false);
    running = true;

    if (ensureAtTop(grid, productId)) {
      running = false;
      return Promise.resolve(true);
    }

    if (!allowFetch || hasActiveFilters()) {
      running = false;
      return Promise.resolve(false);
    }

    var colPath = collectionPath(grid);
    return fetchCollectionProduct(colPath, productId)
      .then(function (product) {
        if (!product || !product.handle) return false;
        // Re-check DOM in case load-more raced
        if (ensureAtTop(grid, productId)) return true;
        return fetchProductCard(product.handle).then(function (html) {
          if (ensureAtTop(grid, productId)) return true;
          return injectCard(grid, productId, html);
        });
      })
      .catch(function () {
        return false;
      })
      .finally(function () {
        running = false;
      });
  }

  function observeGrid() {
    var grid = getGrid();
    if (!grid || grid.getAttribute('data-bambe-pin-observed') === 'true') return;
    grid.setAttribute('data-bambe-pin-observed', 'true');
    var timer = null;
    var obs = new MutationObserver(function () {
      if (!getPinId()) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        ensureAtTop(getGrid() || grid, getPinId());
      }, 50);
    });
    obs.observe(grid, { childList: true });
  }

  function init() {
    var pinId = getPinId();
    if (!pinId) return;
    rememberPin(pinId);
    observeGrid();
    runPin({ allowFetch: true });
  }

  window.BambeCollectionPin = {
    init: init,
    run: runPin,
    getPinId: getPinId,
    preserveParam: function (searchParams) {
      var pin = getPinId();
      if (!pin) return searchParams || '';
      try {
        var params = new URLSearchParams(searchParams || '');
        if (!params.has('p')) params.set('p', pin);
        return params.toString();
      } catch (e) {
        return searchParams || '';
      }
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('bambe:collection-grid-updated', function () {
    observeGrid();
    runPin({ allowFetch: !hasActiveFilters() });
  });

  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
